// @flow

import * as React from 'react';
import {Link} from 'docs/components';
import {Card, CardFooter, CardHeader} from './framework';
import type {CardBadgeDefinition} from './framework';

type CodeSampleCardProps = {|
  badge: CardBadgeDefinition,
  href: string,
  tags: Array<string>,
  title: string,
|};

export const CodeSampleCard = ({
  badge,
  href,
  tags,
  title,
}: CodeSampleCardProps) => (
  <Card bordered>
    <Link href={href} title={title}>
      <CardHeader text={title} badge={badge} />
      <CardFooter
        icon={href.startsWith('https://github.com') ? 'github' : 'product'}
      >
        {tags.join(' · ')}
      </CardFooter>
    </Link>
  </Card>
);
